import { render, staticRenderFns } from "./notice_deteils.vue?vue&type=template&id=08b2b1e4&scoped=true&"
import script from "./notice_deteils.vue?vue&type=script&lang=ts&"
export * from "./notice_deteils.vue?vue&type=script&lang=ts&"
import style0 from "./notice_deteils.vue?vue&type=style&index=0&id=08b2b1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2b1e4",
  null
  
)

export default component.exports